const VIDEO_CONSULTATION_WINDOW_STATE_KEY = 'videoConsultationState';
type WindowStorageState = {
   locked: boolean;
};

export const videoConsultationStorage = {
   setState: (state: WindowStorageState): void => {
      window.localStorage.setItem(VIDEO_CONSULTATION_WINDOW_STATE_KEY, JSON.stringify(state));
   },
   getState: (): WindowStorageState => {
      const item = window.localStorage.getItem(VIDEO_CONSULTATION_WINDOW_STATE_KEY);

      if (item === null) {
         return {
            locked: false,
         };
      }

      return JSON.parse(item);
   },
};
